export const copyTextToClipboard = (text) => {
  navigator.clipboard.writeText(text)
  .then(() => alert(`${text} copied to clipboard!`))
  .catch((err) => alert(`Failed to copy ${text}: `, err));
};